import * as React from 'react';
import {
    Audience,
    MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES,
    Project
} from '@nexxt/common/types';

import { MULTIPLE_ANSWER_TYPES } from '../../../../constants/question';

interface AudienceSummaryProps {
    audience: Audience;
    currentProject: Project;
}

const AudienceSummary = (props: AudienceSummaryProps): JSX.Element => {
    // Not multiple ans -> terminateEnabled === false, option is selected
    // Is multiple ans -> ruleType === MUST_SELECT, option is selected
    const isSelected = (option, isMultipleAns) => {
        return isMultipleAns
            ? option.mode.ruleType ===
                  MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES.MUST_SELECT
            : !option.mode?.terminateEnabled;
    };
    const isEmpty =
        props.audience.builtInAudienceRules.length === 0 &&
        props.audience.customAudienceRules.length === 0;

    const filteredBuiltInAudienceRules = [
        ...props.audience.builtInAudienceRules
    ].map((rule) => {
        const { selectedQuestion, audienceRuleOptions } = rule;
        const isMultipleAns = MULTIPLE_ANSWER_TYPES.includes(
            selectedQuestion?.type
        );
        const updatedOptions = audienceRuleOptions.filter((opt) =>
            isSelected(opt, isMultipleAns)
        );
        return {
            selectedQuestion,
            audienceRuleOptions: updatedOptions
        };
    });
    const renderOptions = () => {
        const totalAudienceRules = [
            ...filteredBuiltInAudienceRules,
            ...props.audience.customAudienceRules
        ];
        return totalAudienceRules.map(
            ({ selectedQuestion, audienceRuleOptions }) => {
                return (
                    <div
                        className="questions-container--question"
                        key={selectedQuestion.questionId}
                    >
                        <div className="q-header">{selectedQuestion.label}</div>

                        {renderAudienceRuleOptions(
                            selectedQuestion,
                            audienceRuleOptions
                        )}
                    </div>
                );
            }
        );
    };

    const renderAudienceRuleOptions = (
        selectedQuestion,
        audienceRuleOptions
    ) => {
        const isBuiltIn = typeof selectedQuestion.value === 'string';
        const isMultipleAns = MULTIPLE_ANSWER_TYPES.includes(
            selectedQuestion?.type
        );
        switch (true) {
            case isMultipleAns && isBuiltIn:
                return audienceRuleOptions.map((opt) => (
                    <div
                        className="questions-container--question--option"
                        key={opt.id}
                    >
                        <span>{opt.label}</span>
                    </div>
                ));
            case isMultipleAns:
                return audienceRuleOptions.map((opt) => {
                    const selectedRuleType =
                        opt?.mode?.ruleType ||
                        MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES.DISQUALIFY;
                    const ruleType =
                        selectedRuleType ===
                        MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES.DISQUALIFY
                            ? 'Disqualify'
                            : selectedRuleType ===
                              MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES.MAY_SELECT
                            ? 'May Select'
                            : 'Must Select';
                    return (
                        <div
                            className="questions-container--question--option"
                            key={opt.id}
                        >
                            <span>{opt.label}</span>
                            <span>{ruleType}</span>
                        </div>
                    );
                });
            case isBuiltIn:

            default:
                const toggle = audienceRuleOptions?.some(
                    (opt) => opt.mode?.quotaEnabled
                );
                const findResponse = (opt) => {
                    let res = '';
                    if (toggle) {
                        res = opt.sampleSize.max;
                    } else {
                        if (!isBuiltIn) {
                            res = isSelected(opt, isMultipleAns)
                                ? 'Qualify'
                                : 'Disqualify';
                        }
                    }
                    return res;
                };
                return audienceRuleOptions.map((opt) => (
                    <div
                        className="questions-container--question--option"
                        key={opt.id}
                    >
                        <span>{opt.label}</span>
                        <span>{findResponse(opt)}</span>
                    </div>
                ));
                break;
        }
    };
    return (
        <div className="audience--summary">
            <span className="audience--summary--header">Summary</span>
            {isEmpty ? (
                <div className="empty">
                    Add a built-in targeting option or custom screener question
                    to get started
                </div>
            ) : (
                <div className="questions-container">
                    <div className="questions-container--question">
                        <div className="q-header">Country</div>
                        {props.currentProject.countries.map((country) => (
                            <div
                                className="questions-container--question--option"
                                key={country.value}
                            >
                                {country.label}
                            </div>
                        ))}
                    </div>
                    {renderOptions()}
                </div>
            )}
        </div>
    );
};
export default AudienceSummary;
